<template>
    <div class="modal-dialog new-modal-dialog">
        <div class="modal-content callback" v-if="modalData.type === 'callback'" v-click-outside="closeModal">

            <button type="button" class="close" data-dismiss="modal" @click="closeModal"></button>

            <div class="row m-0">
                <div class="col-12 col-md-6 left">
                    <h4 class="modal-title">
                        {{ Lang.get('js.callback_form.title') }}
                    </h4>
                    <div class="modal-body">
                        <form-call-back :order="modalData.product_id"></form-call-back>
                    </div>
                </div>
                <div class="col-12 col-md-6 right">
                    <div class="list-block">
                        <ul>
                            <li class="item-services-ask">
                                <p class="text-services-ask">Бесплатная диагностика</p>
                            </li>
                            <li class="item-services-ask">
                                <p class="text-services-ask">Официальная гарантия</p>
                            </li>
                            <li class="item-services-ask">
                                <p class="text-services-ask">Надежные запчасти</p>
                            </li>
                            <li class="item-services-ask">
                                <p class="text-services-ask">Быстрый ремонт</p>
                            </li>
                        </ul>
                    </div>

                    <div class="block-person d-block d-flex align-items-center">
                        <div class="block-img">
                            <img src="../../images/author2.jpg" :alt="Lang.get('js.name_manager')"/>
                        </div>
                        <div class="description-person">
                            <p class="title-person">{{ Lang.get('js.personnel_department') }}</p>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <div class="modal-content" v-if="modalData.type === 'makerequest'">

            <button type="button" class="close" data-dismiss="modal"></button>
            <h4 class="modal-title">
                {{ Lang.get('js.callback_form.title') }}
            </h4>
            <div class="modal-body">
                <form-contacts></form-contacts>
            </div>
        </div>
        <div class="modal-content" v-if="modalData.type === 'login'">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <auth-component></auth-component>
            </div>
        </div>
    </div>
</template>

<script>
    import FormCallBack from './forms/FormCallBack';
    import AuthComponent from './auth/AuthComponent';
    import FormContacts from "./forms/FormContacts";
    import ClickOutside from 'vue-click-outside';

    export default {
        name: "modal-master",
        components: {
            FormContacts,
            FormCallBack,
            AuthComponent,
        },
        props: {
            modalData: {
                required: true,
                type: Object
            },
        },
        data() {
            return {
                Lang,
            }
        },
      methods: {
        closeModal() {
          this.modalData.product_id = '';
          this.modalData.type = '';
          $("#main-modal").modal("hide");
        },
      },
      directives: {
        ClickOutside
      },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/ModalMaster.vue